module.exports = __webpack_public_path__ + "img/avatar4.c2f483c2.png";